import { useShiftPresets } from "@/api/Shifts";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { t } from "@lingui/core/macro";
import * as Sentry from "@sentry/react";
import { deducedError } from "@/Utils/ErrorUtils";
import { UnstyledLink } from "@medoma/components/Link/Link";
import styles from "./ShiftTemplates.module.scss";
import { ShiftTemplateItem } from "./ShiftTemplateItem";

export const ShiftTemplates = () => {
  const { data: shiftTemplates, isPending, isError, error } = useShiftPresets();

  if (isPending) {
    return <Loading message={t`Hämtar mallar`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta mallar`}. ${deducedError(error)}`}
      />
    );
  }

  const sortedShiftTemplates = [...shiftTemplates].sort((a, b) => {
    return (
      a.competence.localeCompare(b.competence) ||
      a.startTime.localeCompare(b.startTime)
    );
  });

  return (
    <ul className={styles.list}>
      {sortedShiftTemplates.map((template) => (
        <li key={template.id}>
          <UnstyledLink
            className={styles.item}
            to={`/commandcenter/shifts/new/templates/${template.id}`}
          >
            <ShiftTemplateItem template={template} />
          </UnstyledLink>
        </li>
      ))}
    </ul>
  );
};
